import { FC } from "react";
import { Outlet } from "react-router-dom";

const VideoTranslate: FC = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default VideoTranslate;
